<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="延长收货" left-arrow fixed
                     @click-left="back"/>
        <div class="c-body">
            <p class="def-color">请再次确认是否需要延长收货?</p>
            <p>订单号: {{orderId}}</p>
            <p class="orange">注意:点击确认后，收货时间增加{{tian}}天</p>
        </div>
        <div class="jump-warphd-foot">
            <van-button size="large" @click="delayedReceipt">提 交</van-button>
        </div>
    </div>
</template>
<script>
    import {NavBar, Cell, CellGroup, Field, Button, Row, Col, Radio, RadioGroup} from "vant";

    export default {
        name: "userorderextend",
        components: {
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Radio.name]: Radio,
            [RadioGroup.name]: RadioGroup
        },
        data() {
            return {
                resId: '1',
                id: this.$route.query.id,
                orderId: this.$route.query.orderId,
                tian: 0
            };
        }, mounted: function () {
            this.getDelayedReceiptDay()
        },
        methods: {
            back() {
                history.back();
            }, getDelayedReceiptDay() {
                let that = this
                that.$api.get(
                    that.jumuc.order.getDelayedReceiptDay,
                    {"orderId": that.id},
                    successRes => {
                        that.tian = successRes.data.delayedReceiptDay
                    }
                )
            }, delayedReceipt() {
                let that = this
                that.$api.post(
                    that.jumuc.order.delayedReceipt,
                    {"orderId": that.id},
                    successRes => {
                        if (successRes.success) {
                            this.$router.push({
                                path: '/user/order'
                            })
                        } else {
                            that.$toast(successRes.msg)
                        }
                    }
                )
            }
        },
    };
</script>
<style lang="less">
    @bule-thame: #3C6EEB;

    .jump-warphd {
        .c-body {
            padding: 10px;
            p {
                font-size: 14px;
                line-height: 38px;
            }
        }
        &-foot {
            padding: 10px 15px;
            font-size: 14px;
            button {
                background-color: @bule-thame;
                color: white;
                font-weight: 700;
                border-radius: 5px;
                margin: 25px 0 10px;
            }
        }
    }
</style>
